import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'
import { FlexCol, FlexItemTablet50, FlexTabletRow } from '@styles/global/flexGrid'
import { PrimaryLockup } from '@styles/global/headlines'

export const SectionOneOuterPadding = styled.div<{customBgColor: string | undefined}>`
  padding: 40px 0;
  z-index: 3;
  position: relative;
  background: ${props => {
  return props.customBgColor ? props.customBgColor : props.theme.backgroundPrimary
}};
  overflow: hidden;
  @media ${device.tablet} {
    padding: 80px 0;
}
`
export const CenterContent = styled(FlexCol)`
  align-items: center;
`
export const ImageContainer = styled.div`
  max-width: 600px;
  padding-top: 2%;
  width: 100%;
`
export const Lockup = styled(PrimaryLockup)`
  h2, h3{
    color: ${props => props.theme.headlineColor};
  }
`
export const Descriptors = styled(FlexTabletRow)`
  margin-top: 30px;
  
  @media ${device.tablet}{
    padding: 0 30px;
  }

  @media ${device.laptop}{
    margin-left: 60px;
    margin-right: 60px;
  }
`
export const DescriptorItem = styled(FlexItemTablet50)`
  padding: 0 30px 20px;
  position: relative;
  h4{
    font-size: 20px;
    font-weight: 600;
    text-transform: inherit;
    margin-top: 0;
  }
  p{
    font-size: 16px;
    font-weight: 400;
    color:  ${props => props.theme.textColor};
    line-height: 28px;
  }
  span{
    display: block;
    width: 20px;
    position: absolute;
    top:7px;
    left:0;
  }
`
